export default function getSiteUrl(site) {
  const { ssl, domain } = site
  const scheme = ssl ? 'https' : 'http'
  return `${scheme}://${domain}/`
}
